import $ from 'jquery';
import Prefixed from '../prefixed/prefixed';

export default class {
	constructor(options) {
		const defaults = {
			el: false,
			classes: {
				base: 'animation',
				animation: {
					band: 'animation_type_band',
					shake: 'animation_type_shake',
					ball: 'animation_type_ball',
					slide: 'animation_type_slide'
				},
				duration: {
					long: 'animation_duration_long',
					longer: 'animation__duration_longer'
				}
			},
			callback: {
				start: false,
				iteration: false,
				end: false
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.prefixed = new Prefixed();
		return this;
	}

	onStart() {
		const self = this;
		if (typeof self.options.callback.start === 'function') {
			self.options.callback.start();
		}
		return self;
	}

	onEnd(animation, duration, event) {
		const self = this;
		const $target = $(event.currentTarget);
		$target
			.removeClass(self.options.classes.animation[animation])
			.removeClass(self.options.classes.base);

		if (self.options.classes.duration[duration]) {
			$target.removeClass(self.options.classes.duration[duration]);
		}
		if (typeof self.options.callback.end === 'function') {
			self.options.callback.end();
		}
		return self;
	}

	update(options) {
		this.options = $.extend(true, {}, this.options, options);
		return this;
	}

	play(animation, duration) {
		const self = this;
		if (self.options.classes.animation[animation]) {
			self.$el.one(self.prefixed.events.animationStart, self.onStart.bind(self));
			self.$el.one(self.prefixed.events.animationEnd, self.onEnd.bind(self, animation, duration));

			if (self.options.classes.duration[duration]) {
				self.$el.addClass(self.options.classes.duration[duration]);
			}
			self.$el
				.addClass(self.options.classes.animation[animation])
				.addClass(self.options.classes.base);
		}
		return self;
	}

	stop(animation, duration) {
		this.$el.off(this.prefixed.events.animationEnd);
		this.$el
			.removeClass(this.options.classes.animation[animation])
			.removeClass(this.options.classes.base);
		if (this.options.classes.duration[duration]) {
			this.$el.removeClass(this.options.classes.duration[duration]);
		}
		if (typeof this.options.callback.end === 'function') {
			this.options.callback.end();
		}
	}
}



// WEBPACK FOOTER //
// ./app/modules/animation/animation.js